<template>
  <div class="site">
    <a class="site_skip" href="#main">Przejdź do treści</a>
    <SiteHeader />
    <main id="main">
      <router-view />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
// Shared chrome for every japoniacars.pl page: masthead, page, colophon.
// Both stay mounted across route changes.

import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'SiteLayout',
  components: { SiteHeader, SiteFooter },
}
</script>

<style scoped>
.site {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.site main {
  flex: 1;
}

/* Visible only once it takes focus. */
.site_skip {
  position: absolute;
  left: -9999px;
  z-index: 200;
  padding: 12px 20px;
  background: #fff;
}

.site_skip:focus {
  left: 0;
}
</style>

<style>
/* Set on <body> while the mobile drawer is open. */
body.has_drawer_open {
  overflow: hidden;
}
</style>
